module.exports = __webpack_public_path__ + "static/media/Cervical Cancer.8565a44a.webp";